module.exports = __webpack_public_path__ + "assets/img/qxiaoyunxcx.b10e082b.jpg";